/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckCircleFilled = createIcon({
  name: 'icon-check-circle-filled',
  content: '<path d="M449.856 706.56l-45.44-45.056 0.128-0.064L268.16 526.016l45.12-45.44 136.32 135.488 270.592-272.384 45.376 45.056-315.712 317.888zM510.528 64A448 448 0 1 0 960 510.528 448 448 0 0 0 510.528 64z" fill="currentColor"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCheckCircleFilled;
